import styled, { keyframes } from 'styled-components';

import { Color } from '../../../constants/Colors';
import { FontType, FontWeight } from '../../../constants/Fonts';
import { MediaQuery, Transition } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const SocialProof = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  transition: ${Transition.OPACITY_EASE};
  justify-content: center;
  align-items: center;
  margin-bottom: 150px;
  min-height: 300px;

  ${MediaQuery.L_AND_DOWN} {
    margin-bottom: 100px;
    min-height: initial;
  }
`;

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-150px * 20));
  }
`;

export const Slider = styled.div`
  height: 100px;
  margin: auto;
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  overflow: hidden;
`;

export const List = styled.div`
  display: flex;
  width: ${({ logoAmount }) => `calc(150px * ${logoAmount})`};
  animation: ${scroll} 60s linear infinite;
`;

export const Item = styled.div`
  height: 70px;
  align-items: center;
  margin: 0 15px;
`;

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 60px;
  padding: 0 100px;

  ${MediaQuery.XL_AND_DOWN} {
    padding: 0 45px;
  }

  ${MediaQuery.S_AND_DOWN} {
    padding: 0 15px;
  }
`;

export const SocialProofTitle = styled.span`
  font-size: 42px;
  color: ${Color.CLOUD_BURST};
  font-weight: ${FontWeight.BLACK};
  font-family: ${FontType.PRIMARY};
`;

export const SocialProofSubTitle = styled.span`
  ${Typography.XXL};
  color: ${Color.CLOUD_BURST};
  font-weight: ${FontWeight.REGULAR};
`;
